import React from 'react';
import { connect } from 'react-redux';

import { MAP_TYPES } from '../../constants';
import { updateMapType as updateMapTypeAction } from '../../store/actions/maps';

import MapViewsMenu from './MapViewsMenu';

export function MapViesMenuWrapperComponent(props) {
  return (
    <MapViewsMenu {...props} />
  );
}

export function mapStateToProps(state) {
  return {
    mapType: MAP_TYPES[(state.viewer.mapType || MAP_TYPES.ROADMAP).toLocaleUpperCase()],
    mapTypes: MAP_TYPES,
  };
}

export function mapDispatchToProps(dispatch) {
  return {
    updateMapType: event => dispatch(updateMapTypeAction(event)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(MapViesMenuWrapperComponent);



// WEBPACK FOOTER //
// ./src/components/MapToolbar/MapViewsMenuWrapper.js